/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ng2-bootstrap-modal/dist/dialog-holder.component';
const styles_DialogHolderComponent:any[] = ([] as any[]);
export const RenderType_DialogHolderComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DialogHolderComponent,data:{}});
function View_DialogHolderComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(0,(null as any),(null as any),0))],(null as any),
      (null as any));
}
export function View_DialogHolderComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{element:0}),(_l()(),i0.ɵand(16777216,[[1,
      3],['element',2]],(null as any),0,(null as any),View_DialogHolderComponent_1))],
      (null as any),(null as any));
}
export function View_DialogHolderComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'dialog-holder',
      ([] as any[]),(null as any),(null as any),(null as any),View_DialogHolderComponent_0,
      RenderType_DialogHolderComponent)),i0.ɵdid(1,49152,(null as any),0,i1.DialogHolderComponent,
      [i0.ComponentFactoryResolver],(null as any),(null as any))],(null as any),(null as any));
}
export const DialogHolderComponentNgFactory:i0.ComponentFactory<i1.DialogHolderComponent> = i0.ɵccf('dialog-holder',
    i1.DialogHolderComponent,View_DialogHolderComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3N0ZXBoL0RvY3VtZW50cy9kZXYvbmVuZGkvbmVuZGktdmlzaW9uLWZyb250L25vZGVfbW9kdWxlcy9uZzItYm9vdHN0cmFwLW1vZGFsL2Rpc3QvZGlhbG9nLWhvbGRlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvc3RlcGgvRG9jdW1lbnRzL2Rldi9uZW5kaS9uZW5kaS12aXNpb24tZnJvbnQvbm9kZV9tb2R1bGVzL25nMi1ib290c3RyYXAtbW9kYWwvZGlzdC9kaWFsb2ctaG9sZGVyLmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vVXNlcnMvc3RlcGgvRG9jdW1lbnRzL2Rldi9uZW5kaS9uZW5kaS12aXNpb24tZnJvbnQvbm9kZV9tb2R1bGVzL25nMi1ib290c3RyYXAtbW9kYWwvZGlzdC9kaWFsb2ctaG9sZGVyLmNvbXBvbmVudC5kLnRzLkRpYWxvZ0hvbGRlckNvbXBvbmVudC5odG1sIiwibmc6Ly8vVXNlcnMvc3RlcGgvRG9jdW1lbnRzL2Rldi9uZW5kaS9uZW5kaS12aXNpb24tZnJvbnQvbm9kZV9tb2R1bGVzL25nMi1ib290c3RyYXAtbW9kYWwvZGlzdC9kaWFsb2ctaG9sZGVyLmNvbXBvbmVudC5kLnRzLkRpYWxvZ0hvbGRlckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjx0ZW1wbGF0ZSAjZWxlbWVudD48L3RlbXBsYXRlPiIsIjxkaWFsb2ctaG9sZGVyPjwvZGlhbG9nLWhvbGRlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7cURDQUE7TUFBQTs7OztvQkNBQTtNQUFBO3NDQUFBLFVBQUE7TUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/~/ng2-bootstrap-modal/dist/dialog-holder.component.ngfactory.ts